import _ from 'lodash';

import { jsonStringify } from 'utils/json';

const DEFAULT_MESSAGE_ROLE = 'assistant';

export const formatMessageRole = message =>
  message?.role ?? message?.author ?? DEFAULT_MESSAGE_ROLE;

export const formatMessageContent = message => {
  if (_.isString(message?.content)) {
    return message.content;
  }

  if (_.isArray(message?.contentBlocks)) {
    return message.contentBlocks.map(block => block.text ?? block.content ?? '').join('\n');
  }

  return jsonStringify(message?.content ?? '', null, 2);
};
